import {InjectionToken, NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {TrackComponent} from './track/track.component';
import {ErrorPageComponent} from './component/error-page/error-page.component';
import {AppUpdatesComponentComponent} from './app-updates-component/app-updates-component.component';

const appUpdatesResolver = new InjectionToken('externalUrlRedirectResolver');

@NgModule({
  imports: [
    RouterModule.forRoot([
      {path: '', component: TrackComponent},
      {path: 'error/:code/:description/:icon/:css_class', component: ErrorPageComponent},
      {path: 'api/appupdates', component: AppUpdatesComponentComponent},
      {path: 'api/appupdate', component: AppUpdatesComponentComponent},
      {path: '**', redirectTo: '', pathMatch: 'full'},
    ], { onSameUrlNavigation: 'reload', useHash: false })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {
}
